/* eslint-disable no-undef */
export const log = (customObj: Record<any, any>) => {
  if (!window.newrelic || typeof window.newrelic.noticeError !== 'function') return;
  const { errTitle = 'Error', ...errValues } = customObj;
  window.newrelic.noticeError(errTitle, errValues);
};

export const addPageAction = (name: string, attributes?: Record<string, any>) => {
  if (!window.newrelic || typeof window.newrelic.addPageAction !== 'function') return;
  window.newrelic.addPageAction(name, attributes);
};
